<template>
  <NoticePopup
    v-if="showNoticePopup && hasCampaignLayerPopup"
    :close-popup-fn="closeEventPopup"
    :open-popup-fn="openEventPopup"
  />
</template>
<script setup>
import { computed, defineProps, ref } from 'vue'
import NoticePopup from '@/components/notice/NoticePopup'
import { getSessionStorage } from '@/common/util/storage.util'
import { SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY } from '@/common/constant'
import utils from '@/common/util/utils'

// campaign types
const CAMPAIGN_TYPE_LAYER_POPUP = 'layerpopup'

const props = defineProps({
  campaign: {
    type: Object,
    default: null
  }
})

const device = ref('')
const showNoticePopup = ref(true)

const campaignList = computed(() => props.campaign?.campaignList ?? [])
const hasCampaignLayerPopup = computed(() =>
  campaignList.value?.some(
    (campaign) => campaign.uid === CAMPAIGN_TYPE_LAYER_POPUP
  )
)

const closeEventPopup = () => {
  getSessionStorage().set(SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY, 'y')
  showNoticePopup.value = false
}

const openEventPopup = () => {
  showNoticePopup.value = true
}

const init = () => {
  device.value = utils.cookies.getDevice() ?? ''

  if (device.value === 'mobile') {
    showNoticePopup.value = true
  }
}

init()

</script>
